export default {"src":"/_next/static/media/caintra.a810b3f3.svg","height":133,"width":133};